export const ids = [
	//
	'draft-job-created', // draft-job is created
	'job-created', // draft-job is finalised
	'job-created-email', // job-created email template is sent
	'job-deleted',
	'job-cancelled',
	'job-duplicated',
	'job-soft-archived', // [ROME-33] softArchivedAt set
	'job-restored', // [ROME-33] softArchivedAt cleared
	//
	'stage-assignee-changed',
	//
	'fps-started',
	'fps-status-changed',
	'fps-ended',
	//
	'jrf-started',
	'jrf-status-changed',
	'jrf-ended',
	//
	'hitl-started',
	'hitl-status-changed',
	'hitl-ended',
	//
	'stage-started',
	'stage-status-changed',
	'stage-ended',
	//
	'aiframe-frame-started',
	'aiframe-frame-ended',
	'aiframe-floor-started',
	'aiframe-floor-ended',
	'aiframe-roof-started',
	'aiframe-roof-ended',
	//
	'truss-hitl-started',
	'truss-hitl-status-changed',
	'truss-hitl-ended',
	//
	'design-status-changed',
	//
	'transaction-created',
	'transaction-updated',
	'transaction-completed',
	'transaction-reworked',
	//
	'details-changed',
	'difficulty-rating-updated',
	'difficulty-rating-org-updated',
	'costings-total-updated',
	// 'volumetrics-total-updated',
	// 'volumetrics-truss-types-updated',
	//
	'file-uploaded',
	'file-downloaded',
	'file-moved',
	'file-deleted',
	'file-version-changed',
	'file-label-set',
	'file-label-reset',
	//
	'folder-created',
	'folder-renamed',
	'folder-deleted',
	//
	'stage-timer-paused',
	'stage-timer-resumed',
	//
	'job-pending', // client view job status turns to pending
	'job-assigned', // client view job status turns to assigned
	'job-in-progress', // client view job status turns to in progress
	'job-completed', // client/bedc view job status turns to completed
	'job-completed-email', // job-completed email is sent
	//
	'itw-rome-job-created',
	'itw-icommand-job-created',
	'itw-icommand-job-details-updated',
	'itw-icommand-sync-enabled',
	'itw-icommand-sync-disabled',
	//
	'file-processing-completed',
	//
	'form-data-changed',
	//
	'timeline-entry-created',
	'timeline-entry-updated',
	'timeline-entry-deleted',
] as const;
